import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
// import { createClient } from "@sanity/client"

import { apiVersion, dataset, projectId, useCdn, perspective } from "./env";

// export const sanityClient = createClient({
//   projectId,
//   dataset,
//   apiVersion,
//   useCdn,
//   perspective
// })

var baseUrl = "https://".concat(projectId, ".apicdn.sanity.io/v").concat(apiVersion, "/data/query/").concat(dataset);

/**
 * Makes a request to the Sanity API.
 * @param {string} groqQuery The GROQ query string.
 * @returns {Promise<any>} A promise that resolves with the Sanity data.
 */
function fetchSanityData(_x) {
  return _fetchSanityData.apply(this, arguments);
}
function _fetchSanityData() {
  _fetchSanityData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(groqQuery) {
    var encodedQuery, url, response, _errorData$error, errorData, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          encodedQuery = encodeURIComponent(groqQuery);
          url = "".concat(baseUrl, "?query=").concat(encodedQuery);
          _context.next = 5;
          return fetch(url);
        case 5:
          response = _context.sent;
          if (response.ok) {
            _context.next = 11;
            break;
          }
          _context.next = 9;
          return response.json();
        case 9:
          errorData = _context.sent;
          throw new Error("Sanity API Error: ".concat(response.status, " ").concat(response.statusText, " - ") + "".concat(((_errorData$error = errorData.error) === null || _errorData$error === void 0 ? void 0 : _errorData$error.description) || JSON.stringify(errorData)));
        case 11:
          _context.next = 13;
          return response.json();
        case 13:
          data = _context.sent;
          return _context.abrupt("return", data.result);
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](0);
          console.error("Error fetching Sanity data:", _context.t0);
          throw _context.t0;
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 17]]);
  }));
  return _fetchSanityData.apply(this, arguments);
}
var sanityClient = {
  fetch: fetchSanityData
};
export { sanityClient };